import { IState } from '../../store';
import { FDealType, getDealType } from '../../utils/deal_type';
import { CurrencySymbol, getPriceRentTimeSuffix, withNoBreakSpaces } from '../../utils/formatters';
import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { IPriceSelectorOptions } from './types';

export function commercialPriceSelector(state: IState, options: IPriceSelectorOptions = {}): string | null {
  const {
    offerData: { offer },
  } = state;

  const { useSharePrefix, currencySign: currencySignOption } = options;

  const dealType = getDealType(offer);
  const postfix = getPriceRentTimeSuffix(offer);
  const sharePrefix = useSharePrefix ? 'за ' : '';
  const currencySign = currencySignOption || CurrencySymbol.Rur;

  if (dealType & FDealType.Rent) {
    if (offer.priceTotalPerMonthRur !== null) {
      if (offer.minPriceTotalPerMonthRur !== null) {
        const from = withNoBreakSpaces(numberToPrettyString(Math.round(offer.minPriceTotalPerMonthRur)));
        const to = withNoBreakSpaces(numberToPrettyString(Math.round(offer.priceTotalPerMonthRur)));

        return `от ${from} до ${to} ${currencySign}${postfix}`;
      }
      const price = withNoBreakSpaces(numberToPrettyString(Math.round(offer.priceTotalPerMonthRur)));

      return `${sharePrefix}${price} ${currencySign}${postfix}`;
    }
  }

  if (offer.priceTotalRur !== null) {
    if (offer.minPriceTotalRur !== null) {
      const from = withNoBreakSpaces(numberToPrettyString(Math.round(offer.minPriceTotalRur)));
      const to = withNoBreakSpaces(numberToPrettyString(Math.round(offer.priceTotalRur)));

      return `от ${from} до ${to} ${currencySign}`;
    }
    const price = withNoBreakSpaces(numberToPrettyString(Math.round(offer.priceTotalRur)));

    return `${sharePrefix}${price} ${currencySign}`;
  }

  return null;
}
